import { render, staticRenderFns } from "./TotalsData.vue?vue&type=template&id=2da1533a"
import script from "./TotalsData.vue?vue&type=script&lang=js"
export * from "./TotalsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports